import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { initAnalytics, initErrorMonitoring } from './lib/analytics.js'

// Initialize analytics and error monitoring (only if env vars are set)
initAnalytics();
initErrorMonitoring();

// ── Environment validation ────────────────────────────────────────────────────
// Fail immediately with a readable error rather than a cryptic runtime crash.
const REQUIRED_ENV = [
  "VITE_SUPABASE_URL",
  "VITE_SUPABASE_ANON_KEY",
];
const missing = REQUIRED_ENV.filter(k => !import.meta.env[k]);
if (missing.length) {
  document.body.innerHTML = `
    <div style="font-family:sans-serif;padding:40px;max-width:520px;margin:60px auto;
                border:1px solid #f09;border-radius:12px;background:#fff0f5;color:#600">
      <h2 style="margin:0 0 12px">Missing environment variables</h2>
      <p>Copy <code>.env.example</code> to <code>.env.local</code> and fill in:</p>
      <ul>${missing.map(k => `<li><code>${k}</code></li>`).join("")}</ul>
    </div>`;
  throw new Error(`Missing required env vars: ${missing.join(", ")}`);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
